import { map } from 'rxjs/operators';
import { Injector } from '@angular/core';

import { SgEntityFetchAdapter } from '../components/entity-select-auto-complete';
import { UsersApiClient, IdentityServerApi } from '@sg/api/identity-server-api';

declare module '../components/entity-select-auto-complete/entity-select-fetch-store.service' {
  export interface SgEntitySelectEntityFetchMap {
    User: {
      entity: IdentityServerApi.UserDto;
      query: IdentityServerApi.SearchUsersRequest;
    };
    UserName: {
      entity: IdentityServerApi.UserDto;
      query: IdentityServerApi.SearchUsersRequest;
    };
  }
}

abstract class BaseUserApiToEntityFetcherLink<T extends 'User' | 'UserName'> implements SgEntityFetchAdapter<T> {
  abstract readonly key: T;
  abstract readonly metadata: {
    idField: keyof IdentityServerApi.UserDto;
    labelField: keyof IdentityServerApi.UserDto;
    queryField?: { field: keyof IdentityServerApi.SearchUsersRequest; isArray?: boolean };
  };

  protected readonly usersApi: UsersApiClient;

  constructor(injector: Injector) {
    this.usersApi = injector.get(UsersApiClient);
  }

  getEntity(id: string) {
    return this.usersApi.usersControllerGetApiIdentityUsersByid({ id }, { observe: 'body' });
  }

  findEntities(query?: IdentityServerApi.SearchUsersRequest, pageNumber?: number) {
    const body: IdentityServerApi.SearchUsersRequest = {};

    if (query) {
      Object.assign(body, query);
    }

    return this.usersApi
      .usersControllerPostApiIdentityUsersSearch(
        { body, pageSize: 10, pageNumber: pageNumber ?? 1 },
        { observe: 'body' }
      )
      .pipe(
        map((result) => {
          return {
            data: result.rows ? result.rows : [],
            infiniteScrollInfo: { currentPage: result.paging.pageNumber, totalPages: result.paging.totalPages },
          };
        })
      );
  }
}

export class UsersApiToEntityFetcherLink extends BaseUserApiToEntityFetcherLink<'User'> {
  readonly key: 'User' = 'User';
  readonly metadata: {
    idField: keyof IdentityServerApi.UserDto;
    labelField: keyof IdentityServerApi.UserDto;
    queryField?: { field: keyof IdentityServerApi.SearchUsersRequest; isArray?: boolean };
  } = {
    idField: 'id',
    labelField: 'username',
    queryField: { field: 'userName' },
  };

  constructor(injector: Injector) {
    super(injector);
  }
}

export class UsersNameApiToEntityFetcherLink extends BaseUserApiToEntityFetcherLink<'UserName'> {
  readonly key: 'UserName' = 'UserName';
  readonly metadata: {
    idField: keyof IdentityServerApi.UserDto;
    labelField: keyof IdentityServerApi.UserDto;
    queryField?: { field: keyof IdentityServerApi.SearchUsersRequest; isArray?: boolean };
  } = {
    idField: 'id',
    labelField: 'username',
    queryField: { field: 'userName' },
  };

  constructor(injector: Injector) {
    super(injector);
  }
}
